import fetch from '@/utils/fetch'

// 获取配置列表
export const List = '/ums/payment/setting/list'


// //获取配置详情
// export function getPaySettingInfo (id) {
//   return fetch({
//     url: 'ums/payment/setting/info' + id,
//     method: 'get'
//   })
// }

// 新建配置
export function createSetting (data) {
  return fetch({
    url: '/ums/payment/setting/create',
    method: 'post',
    data
  })
}

// 修改配置
export function updateSetting (data) {
  return fetch({
    url: '/ums/payment/setting/update',
    method: 'post',
    data
  })
}

/** 删除配置 */
export function deleteSetting (id) {
  return fetch({
    url: `/ums/payment/setting/delete`,
    method: 'post',
    params: {
      id
    }
  })
}
